import classes from "./index.module.css";
import React from "react";

const Loader = () => {
  return <div className={classes.Loader}></div>;
};

export default Loader;
